// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default styling (mobile first approach) */
.banner-pre-footer-container {
    background: url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/PreFooterMobile.jpg') no-repeat;
    background-size: cover;
    background-position: center;
}

/* Tablet: 391px to 834px */
@media screen and (min-width: 391px) and (max-width: 834px) {
    .banner-pre-footer-container {
        background: url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/PreFooterTablet.jpg') no-repeat;
        background-size: cover;
        background-position: center;
    }
}

/* Desktop: 835px and up */
@media screen and (min-width: 835px) {
    .banner-pre-footer-container {
        background: url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/PreFooterDesktop.jpg') no-repeat;
        background-size: cover;
        background-position: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BannerPreFooter/style.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;IACI,6GAA6G;IAC7G,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI;QACI,6GAA6G;QAC7G,sBAAsB;QACtB,2BAA2B;IAC/B;AACJ;;AAEA,0BAA0B;AAC1B;IACI;QACI,8GAA8G;QAC9G,sBAAsB;QACtB,2BAA2B;IAC/B;AACJ","sourcesContent":["/* Default styling (mobile first approach) */\n.banner-pre-footer-container {\n    background: url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/PreFooterMobile.jpg') no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n\n/* Tablet: 391px to 834px */\n@media screen and (min-width: 391px) and (max-width: 834px) {\n    .banner-pre-footer-container {\n        background: url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/PreFooterTablet.jpg') no-repeat;\n        background-size: cover;\n        background-position: center;\n    }\n}\n\n/* Desktop: 835px and up */\n@media screen and (min-width: 835px) {\n    .banner-pre-footer-container {\n        background: url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/PreFooterDesktop.jpg') no-repeat;\n        background-size: cover;\n        background-position: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
